export const generateCanonicalUrl = (
	domain: string,
	path: string,
): string | undefined => {
	return `https://${domain}${path}`;
};
